export default "__VITE_PUBLIC_ASSET__b59debee__"